var baseURLAPI = "https://recette.taxii.ewassali.tn/api/wassalni/";
var baseSocietyURLAPI = "https://recette.business.ewassali.tn/api/v1/";

var updateEmployeURL = "https://recette.business.ewassali.tn/employee/update/";

var assetsBaseURL = "https://assets.marketbey.tn/Wassali/";

var socketUrl = "wss://recette.business.ewassali.tn/wassalni";

export const environment = {
  production: false,
  ogLevel: "debug",

  baseURLAPI: baseURLAPI,
  baseSocietyURLAPI: baseSocietyURLAPI,
  socketUrl: socketUrl,

  updateEmployeURL: updateEmployeURL,

  // PARAMS
  sizePage: 10,

  firebase: {
    apiKey: "AIzaSyC5TJLbBiMzJYYQm_w5mo3ntf4XLEk-tTg",
    authDomain: "wassalny-1cec1.firebaseapp.com",
    projectId: "wassalny-1cec1",
    storageBucket: "wassalny-1cec1.appspot.com",
    messagingSenderId: "1077822351252",
    appId: "1:1077822351252:web:de07dea23ea78be5ca5181",
    measurementId: "G-NV2KP92T1V",
  },

  mqtt: {
    hostname: "recette.taxii.ewassali.tn", // Utilise le domaine actuel
    port: 443, // Port standard HTTPS
    path: "/mqtt", // Chemin configuré dans votre reverse proxy
    protocol: "wss", // WebSocket Secure (obligatoire en HTTPS)
    connectOnCreate: false,
  },

  /********************************************************************* BEGIN NEW SOCIETY APIs */
  /****************** BEGIN SOCIETY ACCOUNT APIs */
  apiBusinessAccountSocieties:
    baseSocietyURLAPI + "society-account/business-account-societies",
  apiBusinessAccountSociety:
    baseSocietyURLAPI + "society-account/business-account-society",
  /****************** END SOCIETY ACCOUNT APIs */

  /****************** BEGIN DOMAIN APIs */
  apiDomainsSociety: baseSocietyURLAPI + "domains/",
  apiNewDomainSociety: baseSocietyURLAPI + "domains/new",
  /****************** END DOMAIN APIs */

  /****************** BEGIN USERS SOCIETY APIs */
  apiUsersSociety: baseSocietyURLAPI + "users-society/",
  apiAllUsersSociety: baseSocietyURLAPI + "users-society/all-users/",
  apiAllUsersAddressSociety: baseSocietyURLAPI + "users-society/users-address/",
  /****************** END USERS SOCIETY APIs */

  /****************** BEGIN SOCIETY APIs */
  apiFilterSocieties: baseSocietyURLAPI + "societies/filter",
  apiSearchSocieties: baseSocietyURLAPI + "societies/search-society",
  apiAllSocieties: baseSocietyURLAPI + "societies/",
  apiOneSociety: baseSocietyURLAPI + "societies/",
  apiDataSociety: baseSocietyURLAPI + "societies/data-society/",
  apiNewSociety: baseSocietyURLAPI + "societies/new",
  apiEditSociety: baseSocietyURLAPI + "societies/edit",

  apiAddResponsableSociety:
    baseSocietyURLAPI + "societies/add-responsable-society",
  apiEditResponsableSociety:
    baseSocietyURLAPI + "societies/edit-responsable-society",

  apiGenerateSocietyKey: baseSocietyURLAPI + "societies/generate-society-keys",

  apiRangeCoefficientSociety:
    baseSocietyURLAPI + "societies/range-coefficient-society",
  /****************** END SOCIETY APIs */

  /****************** BEGIN SOCIETY Loyalty Program APIs */
  apiGetSocietyLoyaltyPrograms: baseSocietyURLAPI + "society-loyalty",
  apiGetValidateSocietyLoyaltyProgram:
    baseSocietyURLAPI + "society-loyalty/validate",
  apiNewSocietyLoyaltyProgram: baseSocietyURLAPI + "society-loyalty/new",
  apiUpdateSocietyLoyaltyProgram: baseSocietyURLAPI + "society-loyalty",
  /****************** END SOCIETY Loyalty Program APIs */

  /****************** BEGIN STOPS APIs */
  apiGetStopsSociety: baseSocietyURLAPI + "stops-society",
  apiSynchroniseStopsSociety: baseSocietyURLAPI + "stops-society/synchronise",
  /****************** END STOPS APIs */

  /****************** BEGIN POSTS APIs */
  apiPostsSociety: baseSocietyURLAPI + "shifts",
  apiParamsPostsUsersSocieties:
    baseSocietyURLAPI + "shifts/daily-shifts-todo-societies",
  apiParamsPostsUsersSociety:
    baseSocietyURLAPI + "shifts/daily-shifts-todo-society",
  /****************** END POSTS APIs */

  /****************** BEGIN ACTIVITY APIs */
  apiActivitiesSociety: baseSocietyURLAPI + "activities/society",
  /****************** END ACTIVITY APIs */

  /****************** BEGIN SITES APIs */
  apiAddSiteSociety: baseSocietyURLAPI + "sites/new",
  apiSitesSociety: baseSocietyURLAPI + "sites/society",
  /****************** END SITES APIs */

  /****************** BEGIN NEW PLANNING APIs */
  apiPlanningUsersSocieties: baseSocietyURLAPI + "planning/planning-societies",
  apiPlanningUsersSociety: baseSocietyURLAPI + "planning/planning-society",

  apiEditUserSociety: baseSocietyURLAPI + "planning/edit-planning-user-society",
  apiInitializePlanningUserSociety:
    baseSocietyURLAPI + "planning/initialize-planning-user",
  /****************** END NEW PLANNING APIs */

  /****************** BEGIN PLANNING EXECUTION APIs */
  apiGenerateTripGroups: baseSocietyURLAPI + "trip-groups/generate",
  apiExecutePlanningUsersSocieties:
    baseSocietyURLAPI + "planning-execution/execute-planning-societies",
  apiExecutePlanningUsersSociety:
    baseSocietyURLAPI + "planning-execution/execute-planning-society",
  apiExecuteDailyPlanningUsersSociety:
    baseSocietyURLAPI + "planning-execution/execute-daily-planning-society",
  /****************** END PLANNING EXECUTION APIs */

  /****************** BEGIN PLANNING ROOOM APIs */
  apiCurrentPackSocieties:
    baseSocietyURLAPI + "planning-room/current-pack-societies",
  apiCurrentTripsBySociety:
    baseSocietyURLAPI + "planning-room/current-rooms-society",

  apiReAssignRoomToDriver:
    baseSocietyURLAPI + "planning-room/reassign-planning-room",

  apiGetClosedRoomStatsDrivers:
    baseSocietyURLAPI + "planning-room/closed-room-stats",
  apiDetailsClosedRoomsDriver:
    baseSocietyURLAPI + "planning-room/details-rooms-driver",

  apiOpenRooms: baseSocietyURLAPI + "planning-room/open-rooms",
  apiNotifDriversPlanningUsersSocieties:
    baseSocietyURLAPI + "planning-room/notif-drivers-planning-societies",
  apiNotifDriversPlanningUsersSociety:
    baseSocietyURLAPI + "planning-room/notif-drivers-planning-society",

  apiDisaffectDriverFromRoom:
    baseSocietyURLAPI + "planning-room/disaffect-driver-from-room",

  apiPullUserOfRoom: baseSocietyURLAPI + "trip-groups/remove-passenger",
  // apiPushUsersInRoom: baseURLAPI + 'planning/push-users-in-room',
  apiPushUsersInRoom: baseSocietyURLAPI + "planning-room/push-users-in-room",
  apiNewPlanningRoom: baseSocietyURLAPI + "planning-room/new",

  apiUpdateTimerRoom: baseSocietyURLAPI + "planning-room/update-timer-room",

  apiRoom: baseSocietyURLAPI + "planning-room/room",
  apiDeleteAllRooms: baseSocietyURLAPI + "planning-room/rooms",

  apiMinusPriceRoom: baseSocietyURLAPI + "planning-room/minus-price-room",
  apiPlusPriceRoom: baseSocietyURLAPI + "planning-room/plus-price-room",
  apiMinusDriverPriceRoom:
    baseSocietyURLAPI + "planning-room/minus-driver-price-room",
  apiPlusDriverPriceRoom:
    baseSocietyURLAPI + "planning-room/plus-driver-price-room",
  apiReinitialisePriceRoom:
    baseSocietyURLAPI + "planning-room/reinitialise-price-room",

  apiUpdatePriceRoomAndSocietyCoefficient:
    baseSocietyURLAPI + "planning-room/update-price-coefficient",
  /****************** END PLANNING ROOOM APIs */

  /****************** BEGIN PLANNING SIMULATION ROOOM APIs */
  apiExecuteSimulationSociety:
    baseSocietyURLAPI + "planning-simulation/execute",
  apiRecalculateSimulationPricesSociety:
    baseSocietyURLAPI + "planning-simulation/recalculate-prices",
  apiGetSimulationRoomsSociety: baseSocietyURLAPI + "planning-simulation",
  /****************** END PLANNING SIMULATION ROOOM APIs */

  /****************** BEGIN PLANNING VALIDATION APIs */
  apiAllValidatedPlanningSocieties:
    baseSocietyURLAPI + "planning-validation/all",
  apiPlanningValidationSociety: baseSocietyURLAPI + "planning-validation",
  /****************** END PLANNING VALIDATION APIs */

  /****************** BEGIN TRIPS SOCIETY APIs */
  apiTripsSociety: baseSocietyURLAPI + "trips-society",
  apiTripsSocieties: baseSocietyURLAPI + "trips-society/all",
  apiGetTripsSociety: baseSocietyURLAPI + "trips-society/society",
  apiRegenerateTripSocietyPrice:
    baseSocietyURLAPI + "trips-society/regenerate-price",
  apiAddTripSocietyBonus: baseSocietyURLAPI + "trips-society/add-bonus-price",
  apiExportTripsSocieties:
    baseSocietyURLAPI + "trips-society/export-trips-societies",
  apiCurrentBusinessTrips: baseSocietyURLAPI + "trips-society/current-trips",
  /****************** END TRIPS SOCIETY APIs */

  /****************** BEGIN DRIVER SOCIETY APIs */
  apiBlockDriverSociety: baseSocietyURLAPI + "driver-society/block",
  apiBlockedDriversSociety:
    baseSocietyURLAPI + "driver-society/blocked-drivers",
  apiTrustDriverSociety: baseSocietyURLAPI + "driver-society/trust",
  apiTrustedDriversSociety:
    baseSocietyURLAPI + "driver-society/trusted-drivers",
  apiPullDriverSociety: baseSocietyURLAPI + "driver-society",
  /****************** END DRIVER SOCIETY APIs */

  /****************** BEGIN PRESTATAIRE APIs */
  apiPrestataire: baseURLAPI + "api/prestataires",
  /****************** END PRESTATAIRE APIs */
  /********************************************************************* END NEW SOCIETY APIs */

  // API TRIP
  apiForceClientAscend: baseURLAPI + "trip/force-client-ascend",

  // API Loyalty Program
  apiBaseLoyaltyPrograms: baseURLAPI + "loyalty-programs",
  apiGetValidateLoyaltyProgram: baseURLAPI + "loyalty-programs/validate",
  apiNewLoyaltyProgram: baseURLAPI + "loyalty-programs/new",
  apiAllLoyaltyTriggerType: baseURLAPI + "loyalty-programs/all-type-active",

  // API USER
  apiUsersAuth: baseURLAPI + "teams/auth",
  apiUsersLogout: baseURLAPI + "teams/logout",
  apiUserProfile: baseURLAPI + "teams/profile",
  apiUserSaveToken: baseURLAPI + "teams/save-token",

  // API NOTIFICATION
  apiUserNotification: baseURLAPI + "notifications",
  apiUserNotifications: baseURLAPI + "notifications/all",
  apiClearAllNotifications: baseURLAPI + "notifications/clear-all",

  // API COURSES
  apiGetTrip: baseURLAPI + "race/",
  apiStatus: baseURLAPI + "race/liststatus",
  apiAllCmdsByStatus: baseURLAPI + "race/cmds-all-status",
  apiTimerFluxTripsCmds: baseURLAPI + "race/timer-flux-trips",
  apiStatisticsFluxCmds: baseURLAPI + "race/statistics-flux-cmds",
  apiAllTripByStatus: baseURLAPI + "race/cmds-status-client",
  apiAllTrips: baseURLAPI + "race/trips-client",
  apiAllDailyTrips: baseURLAPI + "race/daily-trips-client",
  apiCountTripsType: baseURLAPI + "race/count-trips-type",
  apiFindDailyTripsByType: baseURLAPI + "race/map-trips-positions",
  apiDeleteRejectedVehicleByTrip: baseURLAPI + "race/delete-rejected-trip",

  // API PROGRESS TRIPS
  apiProgressTripsFlow: baseURLAPI + "race/progress-trips-flow",

  // STOPS
  apiAllStops: baseURLAPI + "race/all-stops",
  apiAddStop: baseURLAPI + "race/add-stop",
  apiEditStop: baseURLAPI + "race/edit-stop",
  apiDeleteStop: baseURLAPI + "race/delete-stop",

  // API DRIVER
  apiAllDriversTaxi: baseURLAPI + "driver/",
  apiUpdateUserDriver: baseURLAPI + "user/update-user",
  apiNewDriver: baseURLAPI + "driver/inscription",
  apiUploadPhoto: "https://logistic.marketbey.tn/api/v0/taxi/upload-photo",
  apiSaveIdCard: baseURLAPI + "driver/id-card",
  apiSaveLicenceCard: baseURLAPI + "driver/driver-license",
  apiSaveProfessionalCard: baseURLAPI + "driver/professional-card",
  apiSaveExploitCard: baseURLAPI + "driver/exploit-card",
  apiSaveVehicleInfos: baseURLAPI + "driver/infos-vehicule",
  apiSaveDriverInfos: baseURLAPI + "driver/infos-driver",
  apiGetMarkModelsVehicle:
    "https://logistic.marketbey.tn/api/v0/taxi/mark-models-taxis",

  // API VEHICLE
  apiVehiclesByTrip: baseURLAPI + "vehicles/drivers-trip/",
  apiVehiclesNearTrip: baseURLAPI + "vehicles/drivers-near-trip",
  apiAllVehicles: baseURLAPI + "vehicles/filter-driver/",
  apiNewSharedDrivers: baseURLAPI + "vehicles/all-vehicles",
  apiAllDriversBus: baseURLAPI + "vehicles/bus-drivers",
  apiPaymentTansportors: baseURLAPI + "token/taxi-payment",
  apiUpdateVehicle: baseURLAPI + "vehicle/",
  apiNewVehicle: baseURLAPI + "vehicle/new",
  apiBestDrivers: baseURLAPI + "vehicles/best-drivers-complete-trips",
  apiDetailsAmountDrivers: baseURLAPI + "vehicles/details-amount-drivers",

  // API Sponsorship
  apiSponsorshipDrivers: baseURLAPI + "sponsorship/sponsorship-drivers",
  apiValidatedSponsorshipDrivers:
    baseURLAPI + "sponsorship/validated-sponsorship-drivers",
  apiExpiredSponsorshipDrivers:
    baseURLAPI + "sponsorship/expired-sponsorship-drivers",
  apiSponsorshipDriver: baseURLAPI + "sponsorship/sponsorship-driver",
  apiGenSponsorshipDriver:
    baseURLAPI + "sponsorship/generate-sponsorship-driver",
  apiGenSponsorshipDrivers:
    baseURLAPI + "sponsorship/generate-sponsorship-drivers",
  apiEditSponsorshipDriver: baseURLAPI + "sponsorship/edit-sponsorship-driver",

  // API STAT TRIPS
  apiGetStatCreationTrips: baseURLAPI + "race/stat-creation-trips",
  apiGetStatCancellationRateTrips:
    baseURLAPI + "race/stat-cancellation-rate-trips",
  apiGetStatRectedDrivers: baseURLAPI + "race/stat-rejected-drivers",
  apiDailyStatisticsTrips: baseURLAPI + "race/daily-statistics-trips",

  // API STAT DRIVER
  apiGetStatInscriptionDriver: baseURLAPI + "driver/stat-inscription-driver",

  // API DRIVER SERVICE
  apiSearchDrivers: baseURLAPI + "driver/search-driver",
  apiBusinessDrivers: baseURLAPI + "driver/drivers-business",
  apiExportReportDrivers: baseURLAPI + "driver/export-report-drivers",
  apiExportDriversAccount: baseURLAPI + "driver/export-drivers-account",
  apiAddCommentDriver: baseURLAPI + "driver/add-comment",
  apiGetDriver: baseURLAPI + "driver/",
  apiDataDriver: baseURLAPI + "driver/data-driver",
  apiDriverSummaryCounts: baseURLAPI + "driver/driver-summary-counts/",
  apiTripsDriver: baseURLAPI + "driver/trips-driver",
  apiValidateTansportor: baseURLAPI + "driver/validate-transportor",
  apiBlockedTansportor: baseURLAPI + "driver/block-driver",
  apiDeblockedTansportor: baseURLAPI + "driver/deblock-driver",
  apiDeleteDriver: baseURLAPI + "driver/delete-driver",

  apiChangePassword: baseURLAPI + "user/change-password",
  apiCheckForgetPassword: baseURLAPI + "user/chkforget",
  apiExecuteForgetPassword: baseURLAPI + "user/executeforget",

  // ACCOUNT DRIVER
  apiAddAccountDriver: baseURLAPI + "driver/add-account-driver",
  apiDetailsAccountDriver: baseURLAPI + "driver/details-account-driver",
  apiAddBonusDriver: baseURLAPI + "driver/add-bonus-driver",

  // API DRIVER TRIP
  apiAllDriverTrips: baseURLAPI + "driver/driver-trips",
  apiCurrentDriverTrips: baseURLAPI + "driver/current-driver-trips",

  apiSaveResponsibleDriver: baseURLAPI + "driver/save-responsible-drivers",
  apiOneResponsibleDriver: baseURLAPI + "driver/get-responsible-driver/",
  apiAllResponsiblesDriver: baseURLAPI + "driver/all-responsibles-driver",
  apiAddMemberToResponsible: baseURLAPI + "driver/add-member",
  apiAddPuce: baseURLAPI + "driver/new-sim-card",
  apiEditPuce: baseURLAPI + "driver/edit-sim-card/",
  apiDeleteDriverPuce: baseURLAPI + "driver/delete-driver-sim-card/",
  apiBlockedSimCard: baseURLAPI + "driver/blocked-sim-card/",
  apiBusinessModeDriver: baseURLAPI + "driver/business-mode",
  apiDeletePuce: baseURLAPI + "driver/delete-sim-card/",
  apiGetSimCard: baseURLAPI + "driver/sim-card/",
  apiAllPuces: baseURLAPI + "driver/all-sim-cards",

  apiUpdateDriverStartedRoom: baseURLAPI + "driver/update-driver-started-room",

  // API ROOM DRIVER
  apiGetRoomDriver: baseURLAPI + "driver/room-driver",
  apiGetRoomDrivers: baseURLAPI + "driver/room-drivers",

  // API CONNECTING DRIVER
  apiGetConnectingDriver: baseURLAPI + "driver/connecting-driver",
  apiGetConnectingDrivers: baseURLAPI + "driver/connecting-drivers",
  apiGetRejectionDrivers: baseURLAPI + "driver/rejection-drivers",

  // JOBS
  apiAllJobs: baseURLAPI + "race/data-jobs",
  apiAllSessionsServlet: baseURLAPI + "race/sessions-servlet",

  // SETTING API
  apiGetSettings: baseURLAPI + "setting/get-settings",
  apiEditSettings: baseURLAPI + "setting/edit-settings",
  apiAddCommission: baseURLAPI + "setting/add-commission",
  apiAllServicesTaxi: baseURLAPI + "setting/services-taxi",
  apiAllTypeTaxis: baseURLAPI + "setting/type-taxis",
  apiEditTypeTaxi: baseURLAPI + "setting/edit-type-taxi",
  apiTrackingDriverTaxi: baseURLAPI + "setting/list-tracking-taxi",

  apiDefaultCoefficientSociety:
    baseURLAPI + "setting/default-coefficient-society",
  apiDefaultHeadersExcelFile: baseURLAPI + "setting/default-headers-excel-file",

  apiGlobalPricingParams: baseURLAPI + "setting/global-pricing-params",
  apiGreenParams: baseURLAPI + "setting/green-params",

  // OPTIMIZATION
  apiDataOptimization: baseURLAPI + "race/data-optimization",

  // CLIENTS
  apiAllClients: baseURLAPI + "user/all-clients",
  apiExportClients: baseURLAPI + "user/export-clients",
  apiBlockUserClient: baseURLAPI + "user/block-client",
  apiGetStatInscriptionClient: baseURLAPI + "user/stat-inscription-driver",
  apiGetHistoricUserSociety: baseURLAPI + "user/historic-user",

  // NOTIFICATIONS
  apiSendNotificationUsers: baseURLAPI + "user/send-notification",

  // APIs GOOGLE
  API_GOOGLE_KEY: "AIzaSyCKvIA5Vm1GXWP0Gj3DksZdOIqS7VV5qbc",
  apiSearchPlace: baseURLAPI + "race/get-places",
  apiDetailsPlaceGoogle: baseURLAPI + "race/details-place",

  // URL ASSETS IMAGE
  transportorUsersAssetsBaseURL: assetsBaseURL + "TRANSPORTOR/users-trans/",
  driverTransportorAssetsBaseURL:
    assetsBaseURL + "TRANSPORTOR/driver-taxi/driver-licence/",
  cardTransportorAssetsBaseURL:
    assetsBaseURL + "TRANSPORTOR/driver-taxi/driver-card/",
  vehiculeTransportorAssetsBaseURL:
    assetsBaseURL + "TRANSPORTOR/driver-taxi/driver-vehicule/",
  professionalCardAssetsBaseURL:
    assetsBaseURL + "TRANSPORTOR/driver-taxi/driver-professional-card/",
  patentTransportorAssetsBaseURL:
    assetsBaseURL + "TRANSPORTOR/driver-taxi/driver-exploit-card/",
  logoSocietiesAssetsBaseURL: assetsBaseURL + "SOCIETIES/logo/",
};
